module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "1puzzle-piece.f26e506e.svg";